import { ConsultaAPI_URL } from "../backend/ConsultaAPI";

export const loadRuntimeConfig = async () => {
  const response = await ConsultaAPI_URL('ToolsParams');
  window._env_ = response; // Variáveis globais acessíveis em qualquer lugar
};